routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
    $stateProvider
        .state('activity', {
          url: '/activity',
          template: require('./index.html'),
          controller: 'ActivityController',
          controllerAs: 'activity',
          authRequired: true
        });
}



// WEBPACK FOOTER //
// ./src/app/features/activity/routes.js